import { FDateFormat, fDate } from "../formatTime";
import { ReservationGeneral } from "../../models/mrr/reservationGeneral";

export function fBookingDetails(reservation: ReservationGeneral, format: FDateFormat) {
    return `${reservation.unit_id} ${fDate(reservation.check_in_ISO, format)} - ${fDate(reservation.check_out_ISO, format)}`
}